import * as $runtime from "../runtime.js";
import * as Data$dBifunctor from "../Data.Bifunctor/index.js";
import * as Data$dEither from "../Data.Either/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Effect$dClass from "../Effect.Class/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign$dInternal$dStringify from "../Foreign.Internal.Stringify/index.js";
import * as Foreign$dJSON from "../Foreign.JSON/index.js";
import * as Specular$dFRP$dBase from "../Specular.FRP.Base/index.js";
import * as Specular$dRef from "../Specular.Ref/index.js";
import {_getRawItem, _nuke, _removeRawItem, _setRawItem} from "./foreign.js";
const newEvent = /* #__PURE__ */ Specular$dFRP$dBase.newEvent(Effect$dClass.monadEffectEffect);
const show1 = /* #__PURE__ */ (() => Data$dList$dTypes.showNonEmptyList(Foreign.showForeignError).show)();
const Storage = x => x;
const Key = x => x;
const showKey = {show: v => Data$dShow.showStringImpl(v)};
const setItem = dictEncode => v => v1 => value => v.setRawItem(v1)(Foreign$dInternal$dStringify.unsafeStringify(dictEncode.encode(value)));
const removeItem = v => v1 => v.removeRawItem(v1);
const setItem$p = dictEncode => s => k => v => {
  if (v.tag === "Nothing") { return s.removeRawItem(k); }
  if (v.tag === "Just") { return s.setRawItem(k)(Foreign$dInternal$dStringify.unsafeStringify(dictEncode.encode(v._1))); }
  $runtime.fail();
};
const nuke = v => v.nuke;
const newtypeStorage = {Coercible0: () => {}};
const newInMemoryStorage$p = () => {
  const ref = {value: Data$dMap$dInternal.Leaf};
  const onModification = newEvent();
  return {
    storage: {
      setRawItem: key => value => {
        const $0 = Data$dMap$dInternal.insert(Data$dOrd.ordString)(key)(value);
        return () => {
          const $1 = ref.value;
          ref.value = $0($1);
          return onModification.fire()();
        };
      },
      getRawItem: key => {
        const $0 = Data$dMap$dInternal.lookup(Data$dOrd.ordString)(key);
        return () => {
          const a$p = ref.value;
          return $0(a$p);
        };
      },
      removeRawItem: key => {
        const $0 = Data$dMap$dInternal.delete(Data$dOrd.ordString)(key);
        return () => {
          const $1 = ref.value;
          ref.value = $0($1);
          return onModification.fire()();
        };
      },
      onModification: onModification.event,
      nuke: () => {
        ref.value;
        ref.value = Data$dMap$dInternal.Leaf;
      }
    },
    ref
  };
};
const newInMemoryStorage = () => {
  const a$p = newInMemoryStorage$p();
  return a$p.storage;
};
const localStorage = () => {
  const onModification = newEvent();
  return {
    setRawItem: key => value => () => {
      _setRawItem(key, value);
      return onModification.fire()();
    },
    getRawItem: key => () => _getRawItem(key, Data$dMaybe.Just, Data$dMaybe.Nothing),
    removeRawItem: key => () => {
      _removeRawItem(key);
      return onModification.fire()();
    },
    onModification: onModification.event,
    nuke: _nuke
  };
};
const doGetItem = dictDecode => {
  const decodeJSON = Foreign$dJSON.decodeJSONWith(dictDecode.decode);
  return v => v1 => {
    const $0 = v.getRawItem(v1);
    return () => {
      const m_rawValue = $0();
      return (() => {
        if (m_rawValue.tag === "Nothing") { return Data$dEither.$Either("Left", "Unable to find Storage key " + Data$dShow.showStringImpl(v1)); }
        if (m_rawValue.tag === "Just") {
          return Data$dBifunctor.bifunctorEither.bimap(err => "Unable to decode Storage key " + Data$dShow.showStringImpl(v1) + ": " + show1(err))(Data$dBifunctor.identity)(decodeJSON(m_rawValue._1));
        }
        $runtime.fail();
      })();
    };
  };
};
const getItem = dictDecode => {
  const doGetItem1 = doGetItem(dictDecode);
  return storage => key => {
    const $0 = doGetItem1(storage)(key);
    return () => {
      const itemOrError = $0();
      if (itemOrError.tag === "Left") { return Data$dMaybe.Nothing; }
      if (itemOrError.tag === "Right") { return Data$dMaybe.$Maybe("Just", itemOrError._1); }
      $runtime.fail();
    };
  };
};
const newPersistentRef = dictMonadFRP => {
  const Monad0 = dictMonadFRP.MonadCleanup1().Monad0();
  const Bind1 = Monad0.Bind1();
  const MonadEffect0 = dictMonadFRP.MonadEffect0();
  const newRef = Specular$dRef.new(MonadEffect0);
  const subscribeDyn_ = Specular$dFRP$dBase.subscribeDyn_(dictMonadFRP);
  const pure1 = Monad0.Applicative0().pure;
  return dictEncode => dictDecode => {
    const getItem1 = getItem(dictDecode);
    return storage => key => defaultValue => Bind1.bind(MonadEffect0.liftEffect((() => {
      const $0 = getItem1(storage)(key);
      return () => {
        const a$p = $0();
        return (() => {
          if (a$p.tag === "Nothing") { return defaultValue; }
          if (a$p.tag === "Just") { return a$p._1; }
          $runtime.fail();
        })();
      };
    })()))(initialValue => Bind1.bind(newRef(initialValue))(ref => Bind1.bind(subscribeDyn_(setItem(dictEncode)(storage)(key))(ref._1))(() => pure1(ref))));
  };
};
const persistentFoldDyn = dictMonadFRP => {
  const Monad0 = dictMonadFRP.MonadCleanup1().Monad0();
  const Bind1 = Monad0.Bind1();
  const liftEffect = dictMonadFRP.MonadEffect0().liftEffect;
  const foldDyn = Specular$dFRP$dBase.foldDyn(dictMonadFRP);
  const subscribeDyn_ = Specular$dFRP$dBase.subscribeDyn_(dictMonadFRP);
  const pure1 = Monad0.Applicative0().pure;
  return dictEncode => dictDecode => {
    const getItem1 = getItem(dictDecode);
    return storage => key => f => defaultValue => event => Bind1.bind(liftEffect((() => {
      const $0 = getItem1(storage)(key);
      return () => {
        const a$p = $0();
        return (() => {
          if (a$p.tag === "Nothing") { return defaultValue; }
          if (a$p.tag === "Just") { return a$p._1; }
          $runtime.fail();
        })();
      };
    })()))(initialValue => Bind1.bind(foldDyn(f)(initialValue)(event))(dyn => Bind1.bind(subscribeDyn_(setItem(dictEncode)(storage)(key))(dyn))(() => pure1(dyn))));
  };
};
const getItemIfExists = dictDecode => {
  const doGetItem1 = doGetItem(dictDecode);
  return storage => key => {
    const $0 = doGetItem1(storage)(key);
    return () => {
      const a$p = $0();
      return (() => {
        if (a$p.tag === "Left") { return Data$dMaybe.Nothing; }
        if (a$p.tag === "Right") { return Data$dMaybe.$Maybe("Just", a$p._1); }
        $runtime.fail();
      })();
    };
  };
};
const blackHoleStorage = {
  setRawItem: v => v1 => () => {},
  getRawItem: v => () => Data$dMaybe.Nothing,
  removeRawItem: v => () => {},
  onModification: Specular$dFRP$dBase.never,
  nuke: () => {}
};
export {
  Key,
  Storage,
  blackHoleStorage,
  doGetItem,
  getItem,
  getItemIfExists,
  localStorage,
  newEvent,
  newInMemoryStorage,
  newInMemoryStorage$p,
  newPersistentRef,
  newtypeStorage,
  nuke,
  persistentFoldDyn,
  removeItem,
  setItem,
  setItem$p,
  show1,
  showKey
};
export * from "./foreign.js";
